/**
 * @ngdoc directive
 * @name Tabulate Typeahead
 *
 * @element input
 *
 * @description
 Used to customize angular strap typeahead with the next features:
 - show all options
 - clear text
 - show actions menu on mobile on typeahead click
 - scroll up/down to active item on up/down click
 *
 * @attributes
 * @param {Boolean} shouldFocusOnInit - focus on init
 * @param {Boolean} disabled - disable field
 *
 * @example
 <input class='form-control'
 type="text"
 name="typeahead"
 ng-model="burrito"
 ng-options='option.name for option in [{ name: "Big" }, { name: "Medium "}, { name: "Small" }]'
 placeholder='Burrito'

 bs-typeahead
 tabulate-typeahead
 />
 */

(function() {
  'use strict';

  directive.$inject = ["$compile", "$timeout", "screenSizeService"];
  app.directive('tabulateTypeahead', directive);

  function directive($compile, $timeout, screenSizeService) {
    return {
      restrict: 'A',
      link: link,
      require: 'ngModel',
      priority: 100
    };

    function link($scope, $element, $attributes, ngModel) {
      var options = $attributes.bsOptions;
      var allOptionsTemplate = '<span ng-if="!hasValue()" ng-click="toggleAllOptions()" class="glyphicon glyphicon-menu-down form-control__over mod-typeahead"></span>';
      var clearOptionsTemplate = '<span ng-if="hasValue() && !isDisabled()" ng-click="clearOptions()" class="icon-close"></span>';
      var backIconTemplate = '<div class="icon-back mod-mobile-typeahead" ng-click="hide()"></div>';
      var backIcon;
      // do not show no matches when match is selected
      var ngOptionsValuesName = options.match(/in\s+([\s\S]+?)?$/)[1];
      var isMobile = screenSizeService.smallerThan('sm');

      // currently we can keep only the case when function
      // var isNgOptionsFunction = ngOptionsValuesName.indexOf('(') > -1;
      // if (isNgOptionsFunction) {
      //   ngOptionsValuesName = ngOptionsValuesName.substring(0, ngOptionsValuesName.indexOf('()'));
      // }
      init();

      function init() {
        var allOptions = $compile(allOptionsTemplate)($scope);
        $element.after(allOptions);
        var clearOptions = $compile(clearOptionsTemplate)($scope);
        $element.after(clearOptions);
        $attributes.$set('autocomplete', 'off');

        if (isMobile) {
          $scope.$on('$typeahead.select', hideMobile);
          $scope.hide = hideMobile;
        }
        $element.on('keydown', onKeyDown);
        $element.on('focus', onFocus);
        $element.on('blur', onBlur);
        if ($attributes.shouldFocusOnInit === 'true') {
          $timeout(function () {
            $timeout(function () { $element[0].focus(); }, 100);
          });
        }
        $scope.shouldBeShown = shouldBeShown;
      }

      function shouldBeShown() {
        return ngModel.$viewValue.length > 1 && ngModel.$dirty;
      }

      $scope.$watch($attributes.ngModel, function(value) {
        var options = $scope[ngOptionsValuesName];
        if (!options || !value) return;
        $scope.noMatchesIsHidden = options.indexOf(value) > -1;
      });

      // hack to show all options when item is selected
      var option = options.match(/^\s*(.*?)\s+for*/)[1];
      var label = option.indexOf('.') > -1 ? option.split('.')[1] : undefined;
      var allOptionsFormatted;

      function onFocus() {
        var options = $scope[ngOptionsValuesName];
        allOptionsFormatted = allOptionsFormatted || _.map(options, function(item, index) {
          return {
            label: label ? item[label] : item,
            value: item,
            index: index
          };
        });
        if (isMobile && !$scope.isMobileTypeaheadOpened && !$scope.doNotShowMobileSelector) {
          backIcon = $compile(backIconTemplate)($scope);
          jQuery($element).after(backIcon);
          jQuery($element).after('<div class="aside-backdrop mod-mobile-typeahead"></div>');
          $scope.isMobileTypeaheadOpened = true;
          jQuery($element).addClass('active');
        }

        if ($scope.noMatchesIsHidden && $scope.$$childHead.$matches && !$scope.$$childHead.$matches.length && allOptionsFormatted.length) {
          $scope.$$childHead.$matches = allOptionsFormatted;
          $element.trigger('mouseover');
          $element.keydown();
        }
      }

      // scrolls when item is not visible
      function onKeyDown(event) {
        var typeahead = $('.typeahead');
        var active = typeahead.find('li.active');

        if (event.keyCode === 38) {
          active = active.prev();
          scrollToActive();
        } else if (event.keyCode === 40) {
          active = active.next();
          scrollToActive();
        }
        function scrollToActive() {
          if (!active.length) return;

          var topsDifferents = active.offset().top - typeahead.offset().top;
          var heightsDifferents = active.height() - typeahead.height();

          scroll(typeahead, topsDifferents, heightsDifferents);
          scrollToHidden();
        }

        function scrollToHidden() {
          var $window = $(window);
          var topDiff = typeahead.offset().top - $window.scrollTop();
          var heightDiff = typeahead.height() - $window.scrollTop() - $window.height();
          scroll($window, topDiff, heightDiff);
        }

        function scroll(element, topDiff, heightDiff) {
          var bottomDiff = topDiff + heightDiff;
          if (topDiff < 0) {
            element.scrollTop(element.scrollTop() + topDiff);
          } else if (bottomDiff > 0) {
            element.scrollTop(element.scrollTop() + bottomDiff);
          }
        }
      }

      $scope.clearOptions = function () {
        ngModel.$setViewValue();
        ngModel.$render();
        $element[0].focus();
      };

      $scope.hasValue = function () {
        return ngModel.$viewValue;
      };

      $scope.isDisabled = function () {
        return $attributes.disabled;
      };

      //  Icon to show typeahead list
      $scope.isVisibleTypeahead = false;
      $scope.toggleAllOptions = function () {
        $scope.isVisibleTypeahead = !$scope.isVisibleTypeahead;
        $element[0].focus();
      };

      function onBlur() {
        $scope.isVisibleTypeahead = false;
      }

      function hideMobile() {
        jQuery($element).removeClass('active');
        jQuery('.aside-backdrop.mod-mobile-typeahead').remove();
        jQuery('.icon-back.mod-mobile-typeahead').remove();
        $scope.isMobileTypeaheadOpened = false;
        $element.trigger('blur');
      }
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/tabulateTypeaheadDirective.js